import React from "react"
import { useStaticQuery, graphql } from "gatsby"
import { FluidObject } from "gatsby-image"

interface IGetLogo {
  logo: FluidObject
}

const useGetLogo = (): IGetLogo => {
  const { logo } = useStaticQuery(graphql`
    query {
      logo: file(relativePath: { eq: "logo.png" }) {
        childImageSharp {
          fluid(quality: 100, maxWidth: 210) {
            ...GatsbyImageSharpFluid_withWebp
          }
        }
      }
    }
  `)

  return { logo: logo.childImageSharp.fluid }
}
export default useGetLogo
